import './Loading.css';

export default function Loading() {
    return (
        <div className="unique-spinner" />
    )
}
